<template>
    <div class="add-event-type">
        <modal cross-btn="true" size-close-icon="md" size="40%" @close="$emit('close')">
            <div slot="modal-title">
                <h3>Add Company</h3>
            </div>
            <div slot="content">
                <div class="centered vue-loader" style="height: 350px" v-if="loading">
                    <vue-loader></vue-loader>
                </div>
                <div v-else class="form p-b-0-label">
                <el-tabs
                    style="display: flex; justify-content: space-between; flex-direction: column;align-items: center;width: 100%;"
                    v-model="form_type">
                <el-tab-pane class="el-tabs__content" name="Company">
                    <label style="width: 100%" slot="label">Company<span class="danger"></span></label>
                    <el-form  ref="addEventType" :model="taxi_company" :rules="formRules"
                             label-position="top"
                             class="newEventFormStyle">
                        <el-form-item label="Company name" prop="name">
                            <el-input v-model="taxi_company.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Phone number" prop="phone_number">
                            <el-input type="phone-number"  v-model="taxi_company.phoneNumber"></el-input>
                        </el-form-item>
                        <el-form-item label="City" prop="City">
                            <el-select v-model="taxi_company.cityName" placeholder="Select city" style="width: 100%">
                                <el-option
                                        v-for="(city,index) in citys"
                                        :key="index"
                                        :label="city"
                                        :value="city">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                 <el-tab-pane class="el-tabs__content" name="Taxi"> 
                    <label style="width: 100%" slot="label">Driver<span class="danger"></span></label>
                    <el-form ref="addDriver" :model="new_driver" :rules="formRules" label-position="top"
                             class="newEventFormStyle">
                        <el-form-item label="Company name" prop="name">
                            <el-input v-model="new_driver.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Car number" prop="carNumber">
                            <el-input v-model="new_driver.carNumber"></el-input>
                        </el-form-item>
                        <el-form-item label="Email" prop="email">
                            <el-input type="email" v-model="new_driver.email"></el-input>
                        </el-form-item>
                        <el-form-item label="Password" prop="password">
                            <el-input show-password v-model="new_driver.password"></el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                </el-tabs>

                </div>
            </div>
            <div slot="modal-footer">
                <div class="footer-btn">
                    <el-button type="primary" size="small" @click="save()">Save</el-button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import Modal from "@/common/components/Modal";
    import {LoaderIcon} from 'vue-feather-icons'
    import TaxiService from '@/common/services/taxi.service'
    import {Citys} from "../../common/Citys";

    export default {
        name: "AddTaxiCompany",
        components: {Modal, VueLoader: LoaderIcon},
        data() {
            return {
                loading: false,
                taxi_company: {
                    name: null,
                    phoneNumber: null,
                    cityName: 'TETOVO',
                    email: null
                },
                form_type: 'Company',
                formRules: {
                    name: {
                        required: true,
                        trigger: 'change',
                    }
                },
                new_driver: {
                    name: '',
                    carNumber: '',
                    email: '',
                    password: '',
                    baseEmail: null,
                    web: 'TAXI'
                },
                new_driver_rule: {
                    name: {
                        required: true,
                        trigger: 'change',
                    },
                    email: {
                        required: true,
                        trigger: 'change',
                    },
                    password: {
                        required: true,
                        trigger: 'change',
                    }
                },

                citys: Citys
            }
        },
        computed: {
            ...mapState({
                user_email: state => state.user.user_email,
            })
        },
        methods: {

            save() {
                if (this.form_type === 'Company') {
                    this.$refs['addEventType'].validate(valid => {
                        if (valid) {
                            this.loading = true;
                            this.taxi_company.email = this.user_email;
                            TaxiService.addTaxiCompany(this.taxi_company).then(() => {
                                this.$notify.success({
                                    title: `Taxi`,
                                    message: 'Successfully added taxi company'
                                });
                                this.$emit('close')
                            }).catch(error => {
                                this.$notify.error({
                                    title: `Failed to add taxi company`,
                                    message: error.response.data.message
                                });
                            }).finally(() => this.loading = false)
                        } else {
                            return false;
                        }
                    })
                } else {

                    this.$refs['addDriver'].validate(valid => {
                        if (valid) {
                            this.loading = true;
                            TaxiService.AddTaxiDriver(this.new_driver).then(() => {
                                this.$notify.success({
                                    title: `Taxi`,
                                    message: 'Successfully added taxi company'
                                });
                                this.$emit('close')
                            }).catch(error => {
                                this.$notify.error({
                                    title: `Failed to add taxi company`,
                                    message: error.response.data.message
                                });
                            }).finally(() => this.loading = false)
                        } else {
                            return false;
                        }
                    })

                }
            },
        },
        beforeMount() {
            this.new_driver.baseEmail = this.user_email
        }
    }
</script>
<style scoped lang="scss">
    .add-event-type {
        h3 {
            margin: 0;
        }

        .add-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;

            .add-button {
                background-color: #efefef;
                border: 1px solid lightgray;
                width: 100%;
                padding: 10px 0;
                cursor: pointer;
            }
        }

        .form {
            height: 350px;

            .no-image-container {
                background-color: #f8f8f8;
                display: flex;
                width: 100%;
                height: 150px;
                cursor: pointer;

                .no-image-contents {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    flex-direction: column;
                    border-radius: 4px;
                }
            }

            .image-container {
                display: flex;
                justify-content: center;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                cursor: pointer;
            }

        
            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }

        }

        .footer-btn {
            display: flex;
            justify-content: flex-end;
        }

    }
</style>
